import { ROUTE_PATH, OperationType, USER_TYPE } from "common/constants/sm-constants";
import { GridMetaModel, Headers } from "common/models/utility-models/meta-model";

export class TravelDetailGridMetaModel extends GridMetaModel<Headers> {
    constructor() {
        super(
            'Reimbursement Details',
            ROUTE_PATH.travelReimbursement,
            ROUTE_PATH.admintravelReimbursement,
            false,
            false,
            8,
            false,
            false,
            [],
            true,
            [],
            { isDownloadExcel: true, excelFileName: 'reimbursement_details' + new Date().toLocaleDateString() + '.xlsx', btnLabel: 'Download Reimbursement Details', headers: [{ key: 'StudentName', value: 'student_name' }, { key: 'Attended', value: 'attended' }, { key: 'Travel Start Date', value: 'travelStartDate' }, { key: 'Travel End Date', value: 'travelEndDate' }, { key: 'Remarks', value: 'travelTitleOrRemark' }, { key: 'Doc Uploaded Date', value: 'travelDocUploadedDate' }] },
            false,
            { evalKey: '', evalParam: ['1'], decisiveParam: true },
            false,
            true,
            false,
            null,
            { evalKey: '', evalParam: ['1'], decisiveParam: true },
            false,
            null,
            {
                isPreview: false,
                isPreviewType: 'VIDEO',
                isEnvUrl: false,
                linkKey: ['filePath'],
                previewName: ''
            },
            {
                isTabSwitch: false,
                label: '',
                isChecked: false
            },
            true,
            true,
            false,
            [], false, { isExtraActions: false, btnLabel: '' },
            {
                isCheckboxEmit: false,
                emitKey: 'id',
                checkedKey: '',
                valueKey: '',
            },
            {
                isDownload: false,
                key: 'travelDocument',
                valueKey: 'travelDocument',
            },
            {
                isTabStatus: false,
                label: '',
                isChecked: false,
            },
            false,
            false,
            {
                isPrimary: true,
                isDanger: false,
            },
            " ",
            { value: '', isVisible: false },
            false,
            false,
            false,
            {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
                isPreviewBtn: false,
                previewBtnLabel: '',
            },
            { value: '', isVisible: false },
            false,
            null,
            {
                isExtraActions: false,
                btnLabel: '',
                selectOptions: [],
                selectedValue: '',
                isPreviewBtn: false,
                previewBtnLabel: '',
            },
            true

        );
    }

    prepareHeaderList(): Headers[] {
        const headers: Headers[] = [];
        const student_name = new Headers('Student Name', 'student_name', false, true, 'text');
        const attended_flag = new Headers('Attended', 'attended', false, true, 'text');
        const travelStartDate = new Headers('Travel Start Date', 'travelStartDate', false, true, 'text');
        const travelEndDate = new Headers('Travel End Date', 'travelEndDate', false, true, 'text');
        const travelTitleOrRemark = new Headers('Remarks', 'travelTitleOrRemark', false, true, 'text');
        const travelDocUploadedDate = new Headers('Upload Date', 'travelDocUploadedDate', false, true, 'text');
        const preview = new Headers('Travel Document', 'travelDocument', false, true, 'pdf', '0', {
            isColumnNavigation: false,
            navigationUrl: ROUTE_PATH.dashboard,
            navigateOperationType: OperationType.VIEW,
            navigateTransferData: null,
            navigatePageName: 'Uploaded',
        }, null, { isToggle: false, toggleKey: '', toggleCheckedValue: '', toggleUncheckedValue: '' }, true);
        const download = new Headers('', 'travelDocument', false, true, 'downloadPdf',)

        headers.push(student_name);
        headers.push(attended_flag);
        headers.push(travelStartDate);
        headers.push(travelEndDate);
        headers.push(travelTitleOrRemark);
        headers.push(travelDocUploadedDate);
        headers.push(preview);
        headers.push(download);

        return headers;
    }

    // getApprovalStatus() {
    //     const userRole = JSON.parse(localStorage.getItem('profile')).role;
    //     return userRole === USER_TYPE.admin;
    // }
}